import { inmunetApi } from '../../../../../api';

export const getAlergoide = async() => {

    try {

        const { data } = await inmunetApi.get('/configuracionExpedienteClinico/alergoide');

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.alergoide;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const updateAlergoide = async({ data: alergoide }) => {

    try {

        const { data } = await inmunetApi.put(`/configuracionExpedienteClinico/alergoide`, {...alergoide });

        if (!data.status) throw (data.msg) ? data.msg : 'Error al actualizar datos';

        return data.alergoide;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al actualizar datos');
        }

    }

};